import React from 'react'
import PropTypes from 'prop-types'
import { Button } from './'

const Popup = ({ title, text, onClick, buttonText, ...props }) => (
  <div className="popup-wrapper popup-wrapper-guide">
    <div className="popup-guide">
      {title && <h3>{title}</h3>}
      {text && <p>{text}</p>}
      {props.children}
      {
        onClick &&
        <Button
          id="popup-positive"
          positive
          className="float-right"
          onClick={onClick}
        >
          {buttonText || 'Ok'}
        </Button>
      }
    </div>
  </div>
)

Popup.defaultProps = {
  text: '',
  buttonText: '',
  onClick: null,
  children: null,
}

Popup.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  text: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
}

export default Popup



// WEBPACK FOOTER //
// ./src/browser/components/Popup.js